import { call, put, takeLatest } from 'redux-saga/effects';

import { types } from '../constants';
import * as settingsApi from '../api/settings';
import * as attachmentsApi from '../api/attachment';
import { documentType as documentIdType } from '../constants';
import { addAttachments } from './../api/attachment';

function* watchFetchAllDocuments({ documentType, branchId }) {
  try {
    yield put({
      type: types.START_FETCH_ALL_DOCUMENTS,
      currentDocumentType: documentType,
      branchId
    });

    const { jsonData } = yield call(settingsApi.getDocuments, documentType);
    yield put({
      type: types.FETCH_ALL_DOCUMENTS_SUCCESS,
      allDocuments: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_ALL_DOCUMENTS_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_ALL_DOCUMENTS_FINISHED });
  }
}

function* watchFetchAllDocumentsForBranch({ branchId }) {
  try {
    yield put({
      type: types.START_FETCH_ALL_DOCUMENTS,
      currentDocumentType: documentIdType.DOCUMENT_LIBRARY_FOR_BRANCH,
      branchId
    });

    const { jsonData } = yield call(
      attachmentsApi.getDocumentsForBranch,
      branchId
    );
    yield put({
      type: types.FETCH_ALL_DOCUMENTS_SUCCESS,
      allDocuments: jsonData
    });
  } catch (e) {
    yield resolveError(types.FETCH_ALL_DOCUMENTS_FAILURE, e);
  } finally {
    yield put({ type: types.FETCH_ALL_DOCUMENTS_FINISHED });
  }
}

function* watchAddAttachment ( {payload}){
  
try {
  yield put({
    type: types.START_USER_ATTACHMENT_ADD
  });

  let branchId = payload.branchId;
  let currentDirectory = payload.currentDirectory;
  let attachments = payload.attachments;


  const data  = yield call(
    settingsApi.addAttachments,
    currentDirectory,
    branchId,
    attachments
  );

 const attachment = data;

  yield put({
    type: types.USER_ATTACHMENT_ADD_SUCCESS,
    attachment
  });
} catch (e) {
  yield resolveError(types.USER_ATTACHMENT_ADD_FAILURE, e);
} finally {
  yield put({ type: types.USER_ATTACHMENT_ADD_FINISHED,
});
}
  
}


function* watchRemoveAttachment ( {payload}){
  
  try {
    yield put({
      type: types.START_USER_ATTACHMENT_REMOVE
    });
  
    let branchId = payload.branchId;
    const blobName = payload.documentName;
  
    const {jsonData}  = yield call(
      settingsApi.deleteAttachment,
      branchId,
      payload
      );

      if(jsonData === true){
        yield put({
          type: types.USER_ATTACHMENT_REMOVE_SUCCESS,
          blobName
        });
      }

  
  } catch (e) {
    yield resolveError(types.USER_ATTACHMENT_REMOVE_FAILURE, e);
  } finally {
    yield put({ type: types.USER_ATTACHMENT_REMOVE_FINISHED,
  });
  }
    
  }



//This is used to catch all the errors in case of request unsuccessful, and will extract the actual error message.
function* resolveError(type, error) {
  let errorMessageCaptured = false;
  let completeErrorMessage = {};
  if (!error.ok) {
    try {
      const clone = error.clone();
      yield clone.text().then((text) => {
        completeErrorMessage = JSON.parse(text);
        errorMessageCaptured = true;
      });
    } catch (err) {
      errorMessageCaptured = true;
      completeErrorMessage = err;
    }

    if (errorMessageCaptured) {
      const errorMessage = extractErrorMessage(completeErrorMessage);
      yield put({ type, errorMessage });
    }
  }
}

function extractErrorMessage(completeErrorMessage) {
  let errorMessage = '';

  try {
    const message = completeErrorMessage.exceptionMessage
      ? completeErrorMessage.exceptionMessage.split('Content:')[1]
      : completeErrorMessage.messageDetail;

    errorMessage = JSON.parse(message).errorMessage;
    if (!errorMessage) {
      errorMessage = 'An error occured';
    }
  } catch (error) {
    errorMessage = 'An error occured';
  }

  return errorMessage;
}

export default function* settingsWatcher() {
  yield takeLatest(types.FETCH_ALL_DOCUMENTS, watchFetchAllDocuments);
  yield takeLatest(
    types.FETCH_ALL_DOCUMENTS_FOR_BRANCH,
    watchFetchAllDocumentsForBranch
  );
  yield takeLatest(types.USER_ATTACHMENT_ADD, watchAddAttachment);

  yield takeLatest(types.USER_ATTACHMENT_REMOVE, watchRemoveAttachment);
}
